import { useAuthStep } from "@/hooks/useAuthStep";
import { useEffect, useState } from "react";
import Confetti from 'react-confetti';

export const TrialClaimed = () => {

    const { setAuthStep } = useAuthStep();
    const [showConfetti, setShowConfetti] = useState(true);
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNext = () => {
        setAuthStep("questionairre");
    }

    return (
        <div className="px-[30px] flex flex-col gap-2 text-center h-full justify-center mb-20 relative">
            {showConfetti && (
                <Confetti
                    width={windowSize.width}
                    height={windowSize.height}
                    recycle={false}
                    numberOfPieces={150}
                    gravity={0.2}
                    initialVelocityY={-10}
                    wind={0.02}
                    drawShape={(ctx) => {
                        // Draw smaller confetti pieces (radius of 4 pixels)
                        const colors = ['#ef4444', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];
                        const randomColor = colors[Math.floor(Math.random() * colors.length)];
                        ctx.fillStyle = randomColor;
                        ctx.beginPath();
                        ctx.arc(0, 0, 4, 0, 2 * Math.PI);
                        ctx.fill();
                    }}
                    onConfettiComplete={() => setShowConfetti(false)}
                />
            )}
            <h1 className="text-2xl font-semibold">Welcome to Learn+</h1>
            <p className="text-gray-500 mb-6">You can now use all the features of Learn+ for free for 7 days! You can cancel anytime.</p>

            <button onClick={handleNext} className="bg-brand-gradient text-white px-4 py-4 rounded-xl font-semibold">Next</button>
        </div>
    )
}